<template>
   <div id="app" class="h-100">
        <b-container fluid class="bg-teal-700 d-flex align-items-center align-items-sm-center d-print-none">
            <b-row class="text-center mx-auto py-3 my-3">
                <b-col cols="12" class="text-sm-center pr-0">
                    <b-img class="text-center" cols="12" :src="header" fluid></b-img>
                </b-col>
            </b-row>
        </b-container>
	    <navigation-bar/>
        <router-view class="col-12 col-lg-7 h-100" style="min-height: 700px"/>
        <footer-panel/>
    </div>
</template>

<script>
import NavigationBar from './components/SharedComponents/NavigationBar.vue'
import FooterPanel from './components/SharedComponents/FooterPanel.vue'
import axios from 'axios'
export default {
    name: 'App',
    components: {
        NavigationBar,
        FooterPanel
    },
    data() {
        return {
            desktopBackground: null,
            mobileBackground: null,
            windowWidth: 0,
            header: null
        }
    },
    watch: {
        windowWidth(newWidth, oldWidth) {
            this.updateBackground()
        }
    },
    methods: {
        getHeader() {
            axios.get(this.API_URL + '/header').then((response) => {
                 this.header = response.data
            }, (error) => {
                console.log(error)
            })
        },

        getDesktopBackground() {
            axios.get(this.API_URL + '/background/desktop').then((response) => {
                this.desktopBackground = response.data
                this.updateBackground()

            }, (error) => {
                console.log(error)
            })
        },

        getMobileBackground() {
            axios.get(this.API_URL + '/background/mobile').then((response) => {
                this.mobileBackground = response.data
                this.updateBackground()
            }, (error) => {
                console.log(error)
            })
        },

        updateBackground() {
            if (this.windowWidth >= 1200) {
                document.body.style.backgroundImage = `url('${this.desktopBackground}')`
            } else {
                document.body.style.backgroundImage = `url('${this.mobileBackground}')`
            }
        }
    },
    beforeMount() {
        this.getDesktopBackground()
        this.getMobileBackground()
        this.getHeader()
    },
    mounted() {
        this.windowWidth = window.innerWidth
        this.updateBackground()
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            })
        })
    }
}
</script>
<style>
    @font-face {
        font-family: trajan;
        src: url('/static/fonts/trajan.woff2');
    }
    html, body {
        background-repeat: no-repeat;
        background-position: center center;
        background-attachment: fixed;
        -webkit-background-size: 100% 100%;
        -moz-background-size: 100% 100%;
        -o-background-size: 100% 100%;
        background-size: 100% 100%;
    }
    .mqa-title {
        font-family: "trajan" !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue